import stripePromise from './config';

/**
 * Create a Stripe Checkout Session
 * @param {Object} item - The item being purchased
 * @param {string} userEmail - The authenticated user's email
 * @returns {Promise} - Redirects to Stripe Checkout or throws error
 */
export const createCheckoutSession = async (item, userEmail) => {
  try {
    // TODO: Replace with your backend endpoint
    const backendUrl = process.env.REACT_APP_BACKEND_URL || 'http://localhost:5000';
    
    const response = await fetch(`${backendUrl}/api/create-checkout-session`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        itemId: item.id,
        itemName: item.name,
        price: item.price,
        userEmail: userEmail,
        successUrl: `${window.location.origin}/store/success?session_id={CHECKOUT_SESSION_ID}`,
        cancelUrl: `${window.location.origin}/store`,
      }),
    });

    const session = await response.json();

    if (session.error) {
      throw new Error(session.error);
    }

    // Redirect to Stripe Checkout
    const stripe = await stripePromise;
    const { error } = await stripe.redirectToCheckout({
      sessionId: session.id,
    });

    if (error) {
      throw new Error(error.message);
    }
  } catch (error) {
    console.error('Stripe checkout error:', error);
    throw error;
  }
};

/**
 * Verify a Stripe Checkout Session (after successful payment)
 * @param {string} sessionId - The Stripe checkout session ID
 * @returns {Promise<Object>} - The session details
 */
export const verifyCheckoutSession = async (sessionId) => {
  try {
    const backendUrl = process.env.REACT_APP_BACKEND_URL || 'http://localhost:5000';
    
    const response = await fetch(`${backendUrl}/api/verify-session/${sessionId}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });

    const sessionData = await response.json();

    if (sessionData.error) {
      throw new Error(sessionData.error);
    }

    return sessionData;
  } catch (error) {
    console.error('Verify session error:', error);
    throw error;
  }
};
